import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Menu, UserRound } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import { toast } from '../../store/toastStore';
import { Button } from '../ui';

export function Topbar({ onOpenSidebar }: { onOpenSidebar: () => void }) {
  const user = useAuthStore((s) => s.user);
  const signOut = useAuthStore((s) => s.signOut);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    toast.info('Signed out');
    navigate('/login', { replace: true });
  };

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-ink-100 bg-white/90 px-4 backdrop-blur md:px-6">
      <button
        onClick={onOpenSidebar}
        className="rounded-lg p-2 text-ink-600 hover:bg-ink-100 lg:hidden"
        aria-label="Open menu"
      >
        <Menu className="h-5 w-5" />
      </button>

      <div className="flex-1" />

      <div className="relative">
        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="flex items-center gap-2.5 rounded-xl px-2 py-1.5 hover:bg-ink-100"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-100 text-brand-700">
            <UserRound className="h-5 w-5" />
          </span>
          <span className="hidden text-left sm:block">
            <span className="block text-sm font-semibold text-ink-900">{user?.name}</span>
            <span className="block text-xs text-ink-500">{user?.role.name}</span>
          </span>
        </button>

        {menuOpen && (
          <>
            <div className="fixed inset-0 z-10" onClick={() => setMenuOpen(false)} aria-hidden />
            <div className="absolute right-0 z-20 mt-2 w-56 rounded-xl border border-ink-100 bg-white p-2 shadow-pop animate-slide-up">
              <div className="px-3 py-2">
                <p className="text-sm font-semibold text-ink-900">{user?.name}</p>
                <p className="truncate text-xs text-ink-500">{user?.email ?? user?.mobile}</p>
              </div>
              <div className="my-1 border-t border-ink-100" />
              <Button
                variant="ghost"
                size="sm"
                fullWidth
                className="justify-start"
                onClick={handleSignOut}
              >
                <LogOut className="h-4 w-4" />
                Sign out
              </Button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
